import { Outlet } from "@tanstack/react-router"

export const Nodes = () => {
  return <Outlet />
}
